<template>
  <div class="task-form">
    <v-text-field
      :label="$t('msg.name')"
      v-model="model.name"
      :error-messages="errors.collect('name')"
      data-vv-name="name"
      v-validate="'required|max:255'"
      outlined
      :dense="!isMobile"
      hide-details="auto"
      @input="changeName()"
      @change="instantSave"
      ref="name"
    ></v-text-field>
    <v-textarea
      :label="$t('msg.description')"
      v-model="model.desc"
      :error-messages="errors.collect('desc')"
      data-vv-name="desc"
      outlined
      :dense="!isMobile"
      hide-details="auto"
      @input="save()"
      @change="instantSave"
    ></v-textarea>
    <duration
      v-model="model.duration"
      :label="$t('msg.approximateDuration')"
      style="margin-top: 11px"
      @input="save()"
    ></duration>
    <c-date
      v-model="model.day_done"
      :error-messages="errors.collect('day_done')"
      data-vv-name="day_done"
      label="msg.completeTo"
      clearable
      @input="save()"
      class="mt-3"
    ></c-date>
    <v-row class="custom-row" :class="{'custom-row_mobile': $vuetify.breakpoint.xsOnly}">
      <v-col>
        <v-combobox
          v-model="model.tag"
          :label="$t('msg.markers')"
          :error-messages="errors.collect('tags')"
          data-vv-name="tags"
          multiple
          small-chips
          hide-selected
          clearable
          deletable-chips
          outlined
          :dense="!isMobile"
          hide-details="auto"
          @input="save()"
        ></v-combobox>
      </v-col>
      <!--<v-col>
          <v-autocomplete
                  v-model="model.note_id"
                  :label="$t('msg.notes')"
                  :error-messages="errors.collect('note_id')"
                  data-vv-name="note_id"
                  :items="notes"
                  item-text="name"
                  item-value="id"
                  hide-selected
                  clearable
                  deletable-chips
                  outlined
                  dense
                  hide-details="auto"
                  @input="save()"
          ></v-autocomplete>
      </v-col>-->
    </v-row>
    <div
      v-if="parentTask"
      class="color-block color-block_green"
      :class="{'color-block__mobile': $vuetify.breakpoint.xsOnly}"
    >
      <div
        v-if="model.sub_tasks.length > 0"
        class="color-block__label"
      >{{ $t('msg.subTasks') }}
      </div>
      <sub-task
        v-if="model.sub_tasks.length > 0"
        :project-id="projectId"
        :sub-tasks.sync="model.sub_tasks"
        :task-id="model.id"
        @open-sub-task="$emit('open-sub-task', $event)"
        ref="subTask"
        :key="'sub-task-'+model.id"
      ></sub-task>
      <div
        class="task-form__add"
        :class="{
                        'task-form__add_mobile' : $vuetify.breakpoint.xsOnly,
                        'mt-0' : model.sub_tasks.length === 0
                    }"
        @click="$emit('add-sub-task', model.id)"
      >+ {{ $t('msg.addSubtask') }}
      </div>
    </div>
    <div
      class="color-block color-block_gray"
      :class="{'color-block__mobile': $vuetify.breakpoint.xsOnly}"
    >
      <div
        v-if="countItems > 0"
        class="color-block__label"
      >{{ $t('msg.reminders') }}
      </div>
      <task-time
        v-show="countItems > 0"
        ref="taskTime"
        :project-id="projectId"
        :task-id="model.id"
        :count-items.sync="countItems"
      ></task-time>
      <div
        class="task-form__add"
        :class="{
                        'task-form__add_mobile' : $vuetify.breakpoint.xsOnly,
                        'mt-0' : countItems === 0
                    }"
        @click="$refs.taskTime.add()"
      >+ {{ $t('msg.addReminder') }}
      </div>
    </div>
    <color-block
      :label="$t('msg.additionalSettings')"
      :is-fold="true"
    >
      <v-row class="custom-row" :class="{'custom-row_mobile': $vuetify.breakpoint.xsOnly}">
        <v-col>
          <v-autocomplete
            v-model="model.task_id"
            :label="$t('msg.parentTask')"
            :error-messages="errors.collect('task_id')"
            data-vv-name="task_id"
            :items="getTasks"
            item-text="name"
            item-value="id"
            hide-selected
            clearable
            deletable-chips
            outlined
            :dense="!isMobile"
            hide-details="auto"
            @input="changeTaskId()"
            :disabled="!((model.sub_tasks !== null && model.sub_tasks.length === 0) || model.sub_tasks === null)"
          ></v-autocomplete>
        </v-col>
        <v-col v-if="!$vuetify.breakpoint.xsOnly"></v-col>
      </v-row>
      <c-switch
        v-model="model.is_archive"
        hide-details="auto"
        :label="$t('msg.isArchive')"
        @change="submit()"
        class="mt-0"
      ></c-switch>
    </color-block>
  </div>
</template>

<script>
import TaskTime from '../../../components/block/Plan/TaskTime/TaskTime';
import SubTask from '../../../components/block/Plan/SubTask/SubTask';
import Vue from "vue";
import Duration from "../../ui/DurationInput";
import ColorBlock from "../../ui/ColorBlock";
import CDate from '@/components/ui/Date';
import {parse} from "date-fns";

export default {
  components: {Duration, TaskTime, SubTask, ColorBlock, CDate},
  props: {
    model: Object,
    parentTask: Boolean,
    projectId: Number,
    tasks: {type: Array, default: () => []}
  },
  data() {
    return {
      id: undefined,
      subId: undefined,
      formLoading: false,
      modelLoading: false,
      project: {
        name: null
      },
      breadcrumbs: [
        {id: 1, name: null},
        {id: 3, name: null}
      ],
      notes: [],
      notesLoading: false,
      countItems: 0,
      duration: null
    }
  },
  watch: {
    model(v) {
      this.loadedModel(v);
    },
    subId(v) {
      this.subId = v;
    }
  },
  computed: {
    getTasks() {
      let ret = [];

      this.tasks.forEach(task => {
        if (task.id !== this.model.id) {
          ret.push(task);
        }
      });

      return ret;
    }
  },
  methods: {
    loadedModel(model) {
      this.model = model;
      this.breadcrumbs[1].name = this.model.name;
    },
    loadNotes() {
      this.notesLoading = true;
      this.$store.dispatch('loadNotes')
        .then(res => this.notes = res)
        .finally(() => this.notesLoading = false);
    },
    saveTask() {
      this.$store.dispatch('save');
    },
    save(successCallback) {
      this.delay(() => this.submit(successCallback), 1000);
    },
    instantSave() {
      this.delay(() => this.submit(), 0);
    },
    submit(successCallback) {
      let isNew = this.model.id === null;

      let action = isNew ? 'createTask' : 'editTask';

      let model = Object.assign({}, this.model);

      if (model.day_done !== null) {
        let dayDone = parse(model.day_done, 'yyyy-MM-dd', new Date());
        model.day_done = this.timeLocalToServer(dayDone);
      }

      return this.$store.dispatch(action, {
        data: model,
        formErrors: this.errors,
        id: this.projectId,
        subId: this.model.id
      })
        .then(res => {
          this.model.id = res.id;

          if (isNew) {
            this.model.sequence = res.sequence;
          }

          if (typeof successCallback === 'function') {
            successCallback();
          }
        });
    },
    // changeIsArchive() {
    //   console.log('check archive');
    //   this.$emit('change-is-archive', {
    //     id: this.model.id,
    //     taskId: this.model.task_id
    //   });
    // },
    focusName() {
      Vue.nextTick(() => {
        this.$refs.name.focus();
      })
    },
    changeName() {
      this.errors.clear();
      this.save();
    },
    changeTaskId() {
      this.submit(() => {
        this.$emit('change-task-id', this.model);
      });
    },
  },
  created() {
    this.loadNotes();
  }
}
</script>

<style lang="scss">
.task-form {
  & > .v-input {
    margin-top: 10px;

    &:first-child {
      margin-top: 0;
    }
  }

  .task__tasks {
    border-color: #fff;
  }

  .task__task {
    border-color: #fff;
  }
}

.task-form__add {
  cursor: pointer;
  margin-top: 10px;

  &.task-form__add_mobile {
    line-height: 29px;
  }
}
</style>